// Shared theme-driven style helpers for the public form renderers
// (classic in PublicFormPage.js, conversational in ConversationalFormRenderer.js).

export const getInputStyle = (theme) => {
    const base = {
        width: "100%",
        padding: "8px 12px",
        fontSize: `${theme?.fontSize || 14}px`,
        backgroundColor: theme?.inputBgColor || "#ffffff",
        color: "#374151",
        outline: "none",
        boxSizing: "border-box",
        borderRadius: `${theme?.borderRadius || 8}px`,
        transition: "border-color 0.2s, box-shadow 0.2s",
    };
    switch (theme?.inputStyle) {
        case "underline":
            return {
                ...base,
                border: "none",
                borderBottom: `2px solid ${theme?.inputBorderColor || "#d1d5db"}`,
                borderRadius: 0,
                backgroundColor: "transparent",
            };
        case "filled":
            return {
                ...base,
                border: "1px solid transparent",
                backgroundColor:
                    theme?.inputBgColor === "#ffffff"
                        ? "#f3f4f6"
                        : theme?.inputBgColor || "#f3f4f6",
            };
        default:
            return {
                ...base,
                border: `1px solid ${theme?.inputBorderColor || "#d1d5db"}`,
            };
    }
};

export const getButtonStyle = (theme, submitting) => {
    const base = {
        backgroundColor: theme?.primaryColor || "#6366f1",
        color: theme?.buttonTextColor || "#ffffff",
        border: "none",
        padding: "10px 24px",
        fontSize: "15px",
        fontWeight: 600,
        cursor: submitting ? "not-allowed" : "pointer",
        opacity: submitting ? 0.6 : 1,
        transition: "opacity 0.2s, transform 0.1s",
    };
    switch (theme?.buttonStyle) {
        case "pill":
            return { ...base, borderRadius: "9999px" };
        case "square":
            return { ...base, borderRadius: "0px" };
        default:
            return { ...base, borderRadius: `${theme?.borderRadius || 8}px` };
    }
};

export const getShadowStyle = (shadow) => {
    switch (shadow) {
        case "none":
            return "none";
        case "md":
            return "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)";
        case "lg":
            return "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)";
        default:
            return "0 1px 3px rgba(0,0,0,0.1)";
    }
};
